import React, { type PropsWithChildren, type ReactElement } from 'react'
import { Modal } from '../modals/Modal'
import { Button } from '../../components'
import { ButtonVariantType } from '../../types'

export interface ConfirmationModalProps {
  header?: string
  id: string
  primaryAction: {
    label: ReactElement | string
    onClick: (e: React.MouseEvent) => void
    variant?: ButtonVariantType
  }
  secondaryAction?: {
    label: ReactElement | string
    onClick: (e: React.MouseEvent) => void
    variant?: ButtonVariantType
  }
}

export const ConfirmationModal = ({
  children,
  id,
  header,
  primaryAction,
  secondaryAction,
}: PropsWithChildren<ConfirmationModalProps>) => {
  return (
    <Modal id={id} header={header ?? 'Are you sure?'}>
      <div className="bg-light-5 h-[1px] w-full" />
      <div className="my-2 flex flex-col items-center gap-1">{children}</div>
      <div className="flex justify-center gap-4">
        {secondaryAction && (
          <Button
            size={'medium'}
            variant={secondaryAction.variant ?? 'ghost-neutral'}
            onClick={secondaryAction.onClick}
          >
            {secondaryAction.label}
          </Button>
        )}
        <Button size={'medium'} variant={primaryAction.variant ?? 'danger'} onClick={primaryAction.onClick}>
          {primaryAction.label}
        </Button>
      </div>
    </Modal>
  )
}
